import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/fonts/geograph/stylesheet.css'
import './assets/style.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { disableBodyScroll } from 'body-scroll-lock'
import bg from './assets/img/bg.jpg'
import bgIntro from './assets/img/intro.jpg'
import bgGameDescr from './assets/img/gameDescription.jpg'
import bgGameScore from './assets/img/true-or-false-score-bg.jpg'
import bgGameNowYouSeeMe from './assets/img/now-you-see-me-description-bg.jpg'
import bgGameNowYouSeeMeIntro from './assets/img/now-you-see-me-intro.jpg'

const loadImage = (src) => {
  const img = new Image()
  img.src = src
}

loadImage(bg)
loadImage(bgIntro)
loadImage(bgGameDescr)
loadImage(bgGameScore)
loadImage(bgGameNowYouSeeMe)
loadImage(bgGameNowYouSeeMeIntro)
window.fullscreenIframe = false
window.addEventListener('message', (msg) => {
  if (msg.data === 'ngKidsGameIsFullScreen') {
    window.fullscreenIframe = msg.origin
  }
}, false)

disableBodyScroll(document.querySelector('body'))
window.disableScroll = disableBodyScroll

if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) !== null) {
  require('viewport-units-buggyfill').init()
}

Vue.use(BootstrapVue)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
